export const LOAD_CONSUMPTION_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_CONSUMPTION_WIDGET_DATA_REQUEST";
